// src/theme/tokens/hub.js
// Faz 6 · HomeHub anasayfa icin semantic token namespace.
// Hub-spesifik kompozisyonlar (hero, modul kartlari, resume banner) merkezi
// tema sistemini bypass etmemeli · raw palette referanslari yerine bu tokens
// kullanilir. Tum dark mode varyantlari acik tema ile parite tutar.

const hubTokens = {
  // ===== HERO KARTI =====
  // NOT: Hero gradient'i semantic token'da degil, HubHero icinde
  // useColorModeValue ile lokal seciliyor · Chakra v2 `bgGradient` prop'unun
  // semantic-token cozumlemesi tutarsiz davraniyor.
  // Hero ustundeki yarı saydam katman (gradient kontrastini stabilize eder).
  'hub.hero.overlay':     { default: 'blackAlpha.100', _dark: 'blackAlpha.200' },
  // Hero icindeki avatar + chip arka planlari (whiteAlpha tabanli).
  'hub.hero.chipBg':      { default: 'whiteAlpha.200', _dark: 'whiteAlpha.200' },
  'hub.hero.chipBorder':  { default: 'whiteAlpha.400', _dark: 'whiteAlpha.300' },
  'hub.hero.chipLabel':   { default: 'whiteAlpha.800', _dark: 'whiteAlpha.700' },
  // Hero arka süs orb'ı (blur'lu daire).
  'hub.hero.orb':         { default: 'whiteAlpha.200', _dark: 'whiteAlpha.100' },

  // ===== MODÜL KART HOVER OVERLAY =====
  // _groupHover'da kart üstüne dökülen ince katman (light/dark farklı).
  'hub.module.hoverOverlay': { default: 'blackAlpha.50', _dark: 'whiteAlpha.100' },

  // ===== MODÜL TILE (ikon arkalik) RENKLERİ =====
  // Her modülün ikon çerçevesi (Flex tile) için ayri semantic.
  // Light mode'da renkli pastel, dark mode'da hafifce farklilaşmis whiteAlpha
  // tonlari (görsel cesitlilik korunur; eski 'whiteAlpha.100' duzlugu kalkar).
  'hub.tile.solve':      { default: 'blue.50',   _dark: 'rgba(99, 179, 237, 0.12)'  }, // brand mavi
  'hub.tile.browse':     { default: 'gray.100',  _dark: 'whiteAlpha.100'            },
  'hub.tile.flashcards': { default: 'purple.50', _dark: 'rgba(159, 122, 234, 0.14)' },
  'hub.tile.tts':        { default: 'teal.50',   _dark: 'rgba(79, 209, 197, 0.14)'  },
  'hub.tile.coach':      { default: 'green.50',  _dark: 'rgba(104, 211, 145, 0.12)' },
  'hub.tile.mentor':     { default: 'purple.50', _dark: 'rgba(183, 148, 244, 0.14)' },
  'hub.tile.arena':      { default: 'cyan.50',   _dark: 'rgba(76, 201, 240, 0.14)'  },
  'hub.tile.wordle':     { default: 'yellow.50', _dark: 'rgba(246, 173, 85, 0.14)'  },

  // ===== QUICK LINK BUTON =====
  // QuickLinks bloğu icin daha sade arka plan (kart shadow'i kaldirildi).
  'hub.quickLink.bg':       { default: 'bgSecondary',     _dark: 'bgSecondary'      },
  'hub.quickLink.hoverBg':  { default: 'iconButtonHoverBg', _dark: 'iconButtonHoverBg' },
};

export default hubTokens;
